import { useEffect, useState } from "react";

import { Button } from "atoms/button/Button";
import { TextField } from "atoms/text-field/TextField";

import { QuizStepProps } from "../useQuestionnaire";

import YesNo from "./components/YesNo";

export const DiabetesDiagnosis = (props: QuizStepProps) => {
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);

  const handleChange = (value: string) => {
    props.handleStepData("DiabetesDiagnosisQuestion", value);
    props.handleStepData("RecentGlucose", "");
    props.handleStepData("RecentHemoglobin", "");
    if (value === "No") {
      setLastUpdate({ key: "DiabetesDiagnosisQuestion", value });
    }
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [lastUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex h-full flex-col">
      <div className="pb-8 font-serif text-h3">
        Have you been diagnosed with prediabetes or type 2 diabetes?
      </div>
      <div>
        <YesNo
          value={props.data.DiabetesDiagnosisQuestion}
          onChange={(value) => handleChange(value)}
        />
      </div>
      <div hidden={props.data.DiabetesDiagnosisQuestion !== "Yes"}>
        <div className="mt-4 flex flex-col gap-4">
          <TextField
            key="RecentGlucose"
            label="What was your most recent fasting glucose value?"
            inputMode="text"
            placeholder="Glucose (mg/dL)"
            className="!placeholder-shown:text-secondary placeholder:!text-secondary"
            labelClassName="!visible !block"
            placeholderClassName="!hidden"
            type="number"
            value={props.data.RecentGlucose as string}
            onChange={(value) => props.handleStepData("RecentGlucose", value)}
            invalid={!!props.errors?.RecentGlucose}
          />
          <TextField
            key="RecentHemoglobin"
            label="What was your most recent hemoglobin A1c (HbA1c) value?"
            placeholder="Hemoglobin"
            className="!placeholder-shown:text-secondary placeholder:!text-secondary"
            labelClassName="!visible !block"
            placeholderClassName="!hidden"
            type="number"
            value={props.data.RecentHemoglobin as string}
            onChange={(value) =>
              props.handleStepData("RecentHemoglobin", value)
            }
            invalid={!!props.errors?.RecentHemoglobin}
          />
        </div>
        <div
          hidden={
            !props.errors?.RecentHemoglobin && !props.errors?.RecentGlucose
          }
        >
          <p className="mt-2 text-sm text-red">
            Please enter your recent glucose and hemoglobin A1c values.
          </p>
        </div>
      </div>
      {props.data.DiabetesDiagnosisQuestion === "Yes" && (
        <div className="mt-auto">
          <Button fullWidth onClick={() => props.next?.()}>
            Next Question
          </Button>
        </div>
      )}
    </div>
  );
};
